import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAboveAvg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 21,
			width: 23,
			height: 2,
			fill: "#3FC5D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5 14.7333C14.9426 14.7333 17.7333 11.9426 17.7333 8.5C17.7333 5.05743 14.9426 2.26667 11.5 2.26667C8.05743 2.26667 5.26667 5.05743 5.26667 8.5C5.26667 11.9426 8.05743 14.7333 11.5 14.7333ZM11.5 17C16.1944 17 20 13.1944 20 8.5C20 3.80558 16.1944 0 11.5 0C6.80558 0 3 3.80558 3 8.5C3 13.1944 6.80558 17 11.5 17Z",
			fill: "#3FC5D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0469 7.90527H14.8223V9.10156H12.0469V12.2461H10.7754V9.10156H8V7.90527H10.7754V5H12.0469V7.90527Z",
			fill: "#3FC5D6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.8223 6.90527V10.1016H13.0469V13.2461H9.77539V10.1016H7V6.90527H9.77539V4H13.0469V6.90527H15.8223ZM10.7754 7.90527H8V9.10156H10.7754V12.2461H12.0469V9.10156H14.8223V7.90527H12.0469V5H10.7754V7.90527Z",
			fill: "#3FC5D6"
		})
	]
});
export default SvgAboveAvg;
